// extracted by mini-css-extract-plugin
export default {"container":"notFound_container__v2eh-"};